import { observer } from 'mobx-react';
import ApplyViewModel from './ApplyViewModel';
import { Button, InputCalendar } from '../../../../core/components/Index';
import useAsyncEffect from 'use-async-effect';
import { Steps } from './ApplyModels';
import { useParams } from 'react-router-dom';
import Helper, { formatDate } from '../../../../core/services/Helper';
import { Appl } from '../../../../core/Appl';

const RetirementSelectDate = observer(() => {
  const vm = Appl.Services.get<ApplyViewModel>('ApplyViewModel');
  let { memberId } = useParams();
  useAsyncEffect(async () => {
    await vm.loadStepAsync(Steps.SelectDate, memberId!);
  }, []);

  const getDefaultDate = () => {
    let currentDate = new Date();
    // if (vm.model?.personalInformation) {
    //   if (vm.model?.personalInformation.retirementEffDate !== null
    //     && vm.model?.personalInformation.retirementEffDate !== undefined
    //     && vm.model?.personalInformation.retirementEffDate !== "") {
    //     currentDate = vm.model?.personalInformation.retirementEffDate as any;
    //   }
    // }
    // alert(currentDate);
    return currentDate;
  }
  return (
    <>
      {
        vm.submitApplicationValidationMessage !== "" &&
        <>
          <div className="gap-4 p-6 border-[2px] border-[#D82042] bg-[#d8204212] flex rounded-md mb-4" >
            <div><svg viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg" className='w-7 h-7'>
              <path d="M12.5 25.5C15.8152 25.5 18.9946 24.183 21.3388 21.8388C23.683 19.4946 25 16.3152 25 13C25 9.68479 23.683 6.50537 21.3388 4.16117C18.9946 1.81696 15.8152 0.5 12.5 0.5C9.18479 0.5 6.00537 1.81696 3.66117 4.16117C1.31696 6.50537 0 9.68479 0 13C0 16.3152 1.31696 19.4946 3.66117 21.8388C6.00537 24.183 9.18479 25.5 12.5 25.5ZM12.5 6.75C13.1494 6.75 13.6719 7.27246 13.6719 7.92188V13.3906C13.6719 14.04 13.1494 14.5625 12.5 14.5625C11.8506 14.5625 11.3281 14.04 11.3281 13.3906V7.92188C11.3281 7.27246 11.8506 6.75 12.5 6.75ZM10.9375 17.6875C10.9375 17.2731 11.1021 16.8757 11.3951 16.5826C11.6882 16.2896 12.0856 16.125 12.5 16.125C12.9144 16.125 13.3118 16.2896 13.6049 16.5826C13.8979 16.8757 14.0625 17.2731 14.0625 17.6875C14.0625 18.1019 13.8979 18.4993 13.6049 18.7924C13.3118 19.0854 12.9144 19.25 12.5 19.25C12.0856 19.25 11.6882 19.0854 11.3951 18.7924C11.1021 18.4993 10.9375 18.1019 10.9375 17.6875Z" fill="#D82042" />
            </svg>
            </div>
            <div className='-mt-1'>
              <div className='text-[#D82042] text-22px font-semibold mb-1 tracking--1percent'>{vm.submitApplicationValidationMessageTitile}</div>
              <p className="text-black text-15px tracking--1_5percent  ">
                {Helper.formattedHtml(vm.submitApplicationValidationMessage!)}
              </p>
            </div>
          </div>
        </>
      }
      <div className="space-y-6 max-w-4xl text-15px">
        <div>
          <h1 className="text-32px tracking--1percent text-neutral-800 font-semibold mb-4">Retirement Date</h1>
        </div>
        {!vm.retirementDateConfirmed &&
          <>
            <p className="text-black text-15px tracking--1percent leading-6">
              Your retirement date must be the day after your last paid day of work, and it can't be earlier than the date SCERS receives your application. The closer you retire to your next birthday or quarter, the more your benefit increases. Want the cost-of-living adjustment (COLA)? Make sure to retire before April 1st. Keep in mind that early-year retirements can take longer to process, so plan ahead and coordinate with your employer to ensure everything goes smoothly!
            </p>
            <p className="text-gray-900 text-22px font-semibold">When would you like to retire?</p>
            <div style={{ width: '300px' }}>
              <InputCalendar
                id="retirementEffDate"
                value={vm.model?.personalInformation?.retirementEffDate!}
                label="Date of Retirement"
                showHint={true}
                onChange={(e) => {
                  vm.onInputChange(e, 'retirementEffDate', vm.model?.personalInformation);
                }}
                onBlur={async () => await vm.onRetirementDateChangeAsync()}
                required={false}
                minDate={getDefaultDate()}
              />
            </div>
            <div className="flex mt-6 flex-wrap gap-2 sm:flex-nowrap">
              <Button title="Save & Continue" rounded
                onClick={async () => await vm.onSelectDateChangeAsync()}
                disabled={vm.model?.personalInformation?.retirementEffDate === undefined}
              />
              {vm.navigatedFromReviewScreen && <Button title="Cancel & Return to Review" severity='secondary' rounded
                onClick={async () => await vm.navigateToReviewStepAsync()}
              />}
            </div>
          </>
        }
        {vm.retirementDateConfirmed &&
          <div className='space-y-[36px]'>
            <p className="text-gray-900 text-22px font-semibold mb-4 !mt-[36px]">Retirement Date Section Complete! </p>
            <p className="text-gray-900 text-15px mb-4">
              Great! You have selected <b className='text-black'>{formatDate(vm.model.personalInformation.retirementEffDate)}</b> as your retirement date.{' '}
            </p>
            <div className="flex space-x-4 mt-4 !-mb-[0] pt-6">
              {!vm.navigatedFromReviewScreen &&
                <Button title="Save & Continue" rounded
                  onClick={async () => await vm.onSelectDateStepCompleteAsync()} />
              }
              {vm.navigatedFromReviewScreen &&
                <Button title="Return to Review" rounded
                  onClick={() => vm.navigateToReviewStepAsync()} />
              }
              <Button severity="warning" outlined title="Change Date" rounded
                onClick={() => { vm.retirementDateConfirmed = false }} />
            </div>
          </div>
        }
      </div>
    </>
  );
});

export default RetirementSelectDate;
